import React, { useContext } from "react";
import { investorContext } from "../context/context";
import CompanyLogo from "../../assets/company.png";
const InvestorBreadcrumbStart = (props) => {
  const { globalData } = useContext(investorContext);
  const { currentLocation, formData } = globalData;
  let parentDivCrumb = "bg-gray-700";
  let rectangleDivCrumb = "bg-gray-700";
  let triangleDivBorder = "border-l-gray-700";
  let mobileBottomBorder = "border-b-gray-700";

  let title = props.title.toLowerCase();

    parentDivCrumb = "bg-[#92d050]/70";
    rectangleDivCrumb = "bg-[#92d050]/70";
    triangleDivBorder = "border-l-[#92d050]/70";
    mobileBottomBorder = "border-b-[#92d050]/70";

  
  return (
    <>
      {/* mobile */}
      <div
        className={`md:hidden pb-2 border-b-2  h-10 flex items-center justify-center ${mobileBottomBorder} `}
      >
        <img className=" h-full  " src={CompanyLogo} alt="Company" />
      </div>
      {/* Bigger devices */}
      <div
        className={`hidden  md:flex  items-center ${parentDivCrumb} text-white`}
      >
        <div className="flex items-center bg-body">
          <div
            className={`flex items-center h-10 py-0 pl-2.5 text-sm ${rectangleDivCrumb}  rounded-l-full`}
          >
            {props.displayTitle}
          </div>
          <div
            className={`w-0 h-0 border-t-custom border-b-custom border-l-custom border-y-transparent ${triangleDivBorder} border-solid`}
          ></div>
        </div>
      </div>
    </>
  );
};

export default InvestorBreadcrumbStart;
